/** Responsive v1 asset grid. Detail selection remains owned by the page. */

import { cn } from "@/lib/utils"
import type { ClientImageAssetListItem } from "@/services/clientImageAssetsService"
import { AssetCard } from "./AssetCard"

export interface AssetGridProps {
  items: ClientImageAssetListItem[]
  onSelect: (assetId: string) => void
  className?: string
}

export function AssetGrid({ items, onSelect, className }: AssetGridProps) {
  return (
    <div
      data-testid="asset-grid"
      className={cn(
        "grid grid-cols-[repeat(auto-fill,minmax(220px,1fr))] gap-4",
        className,
      )}
    >
      {items.map((item) => (
        <AssetCard key={item.id} item={item} onSelect={onSelect} />
      ))}
    </div>
  )
}

export default AssetGrid
